import { prependBayerStylesheetIfNeeded } from './bayer-vocabulary'
import { normalizeAssistantHtml } from './normalize-assistant-html'
import { removeEmbeddedStyleTags, removeWordConditionalComments } from './remove-word-artifacts'

export function sanitizeAssistantHtmlForBubble(html: string): string {
  if (!html) return html

  // Shared normalization (bullets, vocab gate)
  const normalized = normalizeAssistantHtml(html)
  // Bubble-only: inject Bayer stylesheet so Named Style classes resolve visually
  const withStyles = injectMsoBayerStyleBlock(normalized)
  return wrapTablesForBubble(withStyles)
}

/**
 * What: Strips Word paste artifacts (conditional comments and <style>).
 * Why:  Style blocks can bleed into the rest of the UI,
 *       Word's conditional comments are ignored by browsers but add noise.
 */
export function stripWordArtifactsFromUserBubble(html: string): string {
  if (!html) return html

  let result = removeWordConditionalComments(html)

  result = removeEmbeddedStyleTags(result)

  return result
}

export function injectMsoBayerStyleBlock(html: string): string {
  if (!html) return html
  // Idempotency: if a <style> block is already present we've already injected.
  // Bubble HTML may be re-rendered from the same message multiple times.
  if (/<style[\s>]/i.test(html)) return html
  return prependBayerStylesheetIfNeeded(html)
}

export function wrapTablesForBubble(html: string): string {
  if (!html || !/<table[\s>]/i.test(html)) {
    return html
  }

  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html

  tempDiv.querySelectorAll('table').forEach((table) => {
    if (table.parentElement?.classList.contains('chat-table-scroll')) return

    // Wrap in scrollable container
    const breakout = document.createElement('div')
    breakout.className = 'chat-table-breakout'
    const scroller = document.createElement('div')
    scroller.className = 'chat-table-scroll'

    table.replaceWith(breakout)
    breakout.appendChild(scroller)
    scroller.appendChild(table)
  })

  return tempDiv.innerHTML
}
